import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { InspectionPluginService, ApiService, DataService } from '../../shared/services';
import { Observable, of } from 'rxjs';
import { InspectionPlugin } from '../../shared/models';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';

@Injectable()
export class JobAnalysisPluginService extends InspectionPluginService {
  constructor(protected apiService: ApiService, protected dataService: DataService, factory: InspectionFactoryService) {
    super(apiService, dataService, null, factory);
  }

  public updateJobAnalysis(inspectionId: string, pluginId: string, jobAnalysisItems: any): Observable<any> {
    return this._updateJobAnalysis(inspectionId, pluginId, jobAnalysisItems).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private _updateJobAnalysis(inspectionId: string, pluginId: string, jobAnalysisItems: any): Observable<any> {
    return this.factory
      .updatePluginConfig(inspectionId, null, pluginId, jobAnalysisItems.jobAnalysisItems, 'JobAnalysisItems')
      .pipe(
        flatMap((plugin) => {
          if (this.isInspectionInOffline(inspectionId)) {
            return of(plugin);
          }
          return this.apiService.post(plugin.postServerUrl, plugin.config);
        })
      );
  }

  public getAcceptanceRate(job: any): any {
    let outPutValue =
      (2 * (job.Output.MeasuredPerformance - job.Output.CurrentPerformance)) /
      (job.Output.EstimatedPerformance - job.Output.CurrentPerformance);
    if (isNaN(outPutValue)) outPutValue = 0;
    let setUpValue =
      (job.Setup.CurrentPerformance - job.Setup.MeasuredPerformance) /
      (job.Setup.CurrentPerformance - job.Setup.EstimatedPerformance);
    if (isNaN(setUpValue)) setUpValue = 0;

    return (100 / 3) * (setUpValue + outPutValue);
  }
}
